export const ALL_LISTINGS_KEY = 'ALL_LISTINGS_KEY';
export const FUTURE_AVAILABILITY_EDIT_MAX_DAYS = 366;
export const FUTURE_AVAILABILITY_EDIT_MAX_MONTHS = 12;
export const DIFFERENT_AVAILABLE_SEATS_WITHIN_SLOT_RANGE = 'DIFFERENT_AVAILABLE_SEATS_WITHIN_SLOT_RANGE';
